<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" >
          <template v-slot:body>
              <v-row>
                <v-col cols="12" class="pa-0">
                  <i-card-top
                    class="d-md-flex"
                    outlined
                    :useBtnList="useBtnList"
                    @btnRetrieve="btnRetrieve()" @btnPrintTag="btnPrintTag()" @btnSave="btnSave()"
                  >
                    <template v-slot:body>
                      <v-row no-gutters class="center pa-2 pb-0">
                        <i-label :label="'Ship : '" />
                        <v-col cols="1">
                          <v-select
                            v-model="shipNo"
                            :items="shipNoList"
                            item-value="shipNo"
                            return-object
                            single-line
                            outlined
                            dense
                            @change="changeShipNo"
                          ></v-select>
                        </v-col>
                        <i-label :label="'Rev.No : '" class="pl-2"/>
                        <v-col cols="1" >
                          <v-text-field 
                            v-model="revNo" 
                            dense 
                            outlined 
                            hide-details="auto"
                          />
                        </v-col>
                      </v-row>
                    </template>
                  </i-card-top>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col cols="12" class="pt-1">
                  <DxDataGrid id="epms6100" 
                    :ref="epms6100Ref"
                    class="hipGridHeight1_1"
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="true"
                    :column-hiding-enabled="false" 
                    :sorting="{ mode: 'none' }"
                  >
                    <DxPaging :enabled="true" :page-size="10" />
                    <DxColumn data-field="rnum" caption="No" width="3%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="drumNo" width="10%" data-type="string" alignment="center" header-cell-template="CablePor" :allow-editing="false" />
                    <template #CablePor>
                      <div>CABLE POR<br>DRUM NO.</div>
                    </template>
                    <DxColumn data-field="cableType" caption="TYPE" width="11%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn caption="CABLE LENGTH (MR)" alignment="center">
                      <DxColumn data-field="tot" width="5%" data-type="number" format="0,###" alignment="center" header-cell-template="totalMr" :allow-editing="false"/>
                      <DxColumn caption="Drum" width="5%" alignment="center" >
                        <DxColumn data-field="a" caption="1" width="4%" data-type="number" format="0,###" alignment="center" :allow-editing="false"/>
                        <DxColumn data-field="b" caption="2" width="4%" data-type="number" format="0,###"  alignment="center" :allow-editing="false"/>
                        <DxColumn data-field="c" caption="3" width="4%" data-type="number" format="0,###" alignment="center" :allow-editing="false"/>
                        <DxColumn data-field="d" caption="4" width="4%" data-type="number" format="0,###" alignment="center" :allow-editing="false"/>
                        <DxColumn data-field="e" caption="5" width="4%" data-type="number" format="0,###" alignment="center" :allow-editing="false"/>
                        <DxColumn data-field="f" caption="6" width="4%" data-type="number" format="0,###" alignment="center" :allow-editing="false"/>
                        <DxColumn data-field="g" caption="7" width="4%" data-type="number" format="0,###" alignment="center" :allow-editing="false"/>
                        <DxColumn data-field="h" caption="8" width="4%" data-type="number" format="0,###" alignment="center" :allow-editing="false"/>
                        <DxColumn data-field="i" caption="9" width="4%" data-type="number" format="0,###" alignment="center" :allow-editing="false"/>
                        <DxColumn data-field="j" caption="10" width="4%" data-type="number" format="0,###" alignment="center" :allow-editing="false"/>
                        <DxColumn data-field="k" caption="11" width="4%" data-type="number" format="0,###" alignment="center" :allow-editing="false"/>
                        <DxColumn data-field="l" caption="12" width="4%" data-type="number" format="0,###" alignment="center" :allow-editing="false"/>
                        <DxColumn data-field="m" caption="13" width="4%" data-type="number" format="0,###" alignment="center" :allow-editing="false"/>
                        <DxColumn data-field="n" caption="14" width="4%" data-type="number" format="0,###" alignment="center" :allow-editing="false"/>
                        <DxColumn data-field="o" caption="15" width="4%" data-type="number" format="0,###" alignment="center" :allow-editing="false"/>
                        <DxColumn data-field="p" caption="16" width="4%" data-type="number" format="0,###" alignment="center" :allow-editing="false"/>
                      </DxColumn>
                    </DxColumn>
                    <DxColumn data-field="dispPorNo" caption="POR No" width="10%" data-type="string" alignment="center" :allow-editing="false"/>
                    <template #totalMr>
                      <div>TOTAL<br>MR</div>
                    </template>
                  </DxDataGrid>
                </v-col>
              </v-row>

          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn  } from 'devextreme-vue/data-grid'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import { getShipList , getRevNo } from '@/api/view/hip/6/epms6400.js'
import { getDrumList , epms6110Save } from '@/api/view/hip/6/epms6100.js'
import { reportView} from '@/api/view/hip/common/common.js'
import notify from 'devextreme/ui/notify' // message


export default {
  name: 'epms6100',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    'i-card-top': iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing
    
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      useBtnList: ['btnRetrieve' , 'btnSave' , 'btnPrintTag'],
      epms6100Ref: 'epms6100Ref',
      gridMainList: [],

      shipNo: '',
      shipNoList: [],
      revNo: '',
      
    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.epms6100Ref)
    },
  },
  mounted() {
    this.shipList()
  },
  methods: {
    async shipList(){
      try {
        this.openLoading('searching')
        let params = {
          makerCd: this.$store.state.user.makerCd,
        }
        await getShipList(params).then(res => {
          res.list.forEach(e => {
            this.shipNoList.push(e.shipNo)
          });
        })
      } finally {
        this.endLoading()
      }
    },
    async getList(){
      try {
        this.openLoading('searching')
        let params = {
          shipNo: this.shipNo,
        }
        await getRevNo(params).then(res => {
          if(res.list[0]){
            this.revNo = res.list[0].revNo
          }
        })

      } finally {
        this.endLoading()
        this.getMainList()
      }
    },
    async getMainList(){
      this.openLoading('searching')
      this.gridMainList = []
      try {
        let params = {
          shipNo: this.shipNo,
        }
        await getDrumList(params).then(res => {
          res.list.forEach(e => {
            e.id = e.rnum
            if(e.chk === 'Y'){
              this.gridMainInstance.selectRows([e.id], true)
            }
          });
          this.gridMainList = res.list
        })

      } finally {
      this.endLoading()
      }
    },
    changeShipNo(e){
      this.getList()
    },
    btnRetrieve(){
      this.getList()
    },
    btnPrintTag(){
      const param = {
        fileName: 'drum_list.jrxml',
        as_ship_no: this.shipNo,
      }
      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    async btnSave(){
      await this.gridMainInstance.saveEditData()
      var selectedMainRows = await this.gridMainInstance.getSelectedRowsData()

      if(!this.shipNo || this.shipNo === ''){ return }

      let params = []

      selectedMainRows.forEach(e => {
        if(e.chk !== 'Y'){
          params.push({
            chk: 'Y' , 
            revNo: e.revision, 
            shipNo: e.shipNo, 
            drumNo: e.drumNo, 
            tot: e.tot, 
            makerCd: this.$store.state.user.makerCd
          })
        }
      });
      this.openLoading('searching')
      epms6110Save(params)
        .then(res => {
          notify(this.$t('Finish saving!'), 'success', 3000)
        })
        .catch(error => {
          this.vToastify(error, 'warn')
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
          this.getMainList()
        })
    },
  }
}
</script>
<style lang="scss" scoped>
</style>